import { NavLink } from "react-router-dom";

export const SecondaryButton = ({ btnText, width, url }) => {
  return (
    <NavLink to={url}>
      <button
        className={`bg-white myShadow px-4 py-3 md:px-8 md:py-4 text-black hover:bg-dark-blue hover:text-white rounded-md disabled:opacity-50 ${
          width && width
        }`}
      >
        {btnText}
      </button>
    </NavLink>
  );
};
export const PrimaryButtonOutline = ({ btnText, width, url }) => {
  return (
    <NavLink to={url}>
      <button
        className={`border border-dark-blue myShadow px-4 py-3 md:px-8 md:py-4 text-dark hover:bg-dark-blue hover:text-white rounded-md disabled:opacity-50 ${
          width && width
        }`}
      >
        {btnText}
      </button>
    </NavLink>
  );
};
export const PrimaryButtonOutlineWithIcon = ({ btnText, width, url, icon }) => {
  return (
    <NavLink to={url}>
      <button
        className={`border border-dark-blue myShadow px-4 py-3 md:px-8 md:py-4 flex gap-2 text-dark hover:bg-dark-blue hover:text-white rounded-md disabled:opacity-50 ${
          width && width
        }`}
      >
        <div className="self-center">{icon}</div>
        <span>{btnText}</span>
      </button>
    </NavLink>
  );
};
export const PrimaryButtonWithIcon = ({
  btnText,
  width,
  url,
  icon,
  onClick,
}) => {
  return (
    <NavLink to={url}>
      <button
        className={`bg-dark-blue myShadow px-4 py-3 md:px-8 md:py-4 flex gap-2 text-white hover:bg-none rounded-md disabled:opacity-50 ${
          width && width
        }`}
        onClick={onClick}
      >
        <div className="self-center">{icon}</div>
        <span>{btnText}</span>
      </button>
    </NavLink>
  );
};

export const PrimaryButton = ({ btnText, width, url }) => {
  return (
    <NavLink to={url}>
      <button
        className={`bg-dark-blue rounded-md px-4 py-3 md:px-8 md:py-4 text-white disabled:opacity-50 ${
          width && width
        }`}
      >
        {btnText}
      </button>
    </NavLink>
  );
};
